import ApiService from '../../services/apiService.js';
// import ResizeObserver polfyfill for IE 11 and Edge<19
import { ResizeObserver as ResizeObserverFallback } from '@juggle/resize-observer';
import { vuetifyColors, getContrastYIQ } from '../../utils/themes';
import { mapState, mapGetters } from 'vuex';
import get from 'lodash/get';
import set from 'lodash/set';
export default {
  name: 'CoreAnnouncements',
  computed: {
    ...mapState('app', ['announcements']),
    ...mapGetters({
      sessionUser: 'authentication/user',
      tenantId: 'authentication/tenantId'
    })
  },
  updated() {
    if (this.$refs.announcementsBanners) {
      // check if browser supports ResizeObserver natively
      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(this.onResizeBannerWrapper).observe(this.$refs.announcementsBanners);
      } else {
        new ResizeObserverFallback(this.onResizeBannerWrapper).observe(this.$refs.announcementsBanners);
      }
    }
  },
  methods: {
    closeAnnouncement(announcement) {
      const announcementId = announcement.id;
      const userAnnouncements = get(this.sessionUser, 'properties.announcements', []);
      let index = this.$store.state.app.announcements.findIndex(announcement => announcement.id === announcementId);
      this.$store.state.app.announcements.splice(index, 1);
      if (announcementId) {
        set(this.sessionUser, 'properties.announcements', userAnnouncements.filter(a => parseInt(a) !== parseInt(announcementId)));
        this.updateUser(this.sessionUser, announcement);
      }
    },
    updateUser(userData, announcement) {
      return ApiService.updateUser(userData).then(() => {
        this.updateAnnouncementState(announcement);
      }).catch(error => {
        console.error(error);
      });
    },
    updateAnnouncementState(announcement) {
      return ApiService.tenantUpdateSystemAnnouncementState(this.tenantId, announcement);
    },
    showInfoBanner(announcement) {
      if (!announcement.active || announcement.presentationType !== 'banner') {
        return false;
      }
      const now = new Date();
      const startDate = new Date(announcement.start);
      const endDate = new Date(announcement.end);
      return (announcement.start === null || startDate <= now) && (announcement.end === null || endDate >= now);
    },
    getColor(type) {
      return vuetifyColors[type] || vuetifyColors['info'];
    },
    getTextColor(type) {
      return getContrastYIQ(this.getColor(type), '#333');
    },
    getTypeIcon(type) {
      switch (type) {
        case 'info':
          return 'info-circle';
        case 'success':
          return 'check-circle';
        case 'warning':
          return 'exclamation';
        case 'error':
          return 'exclamation-triangle';
      }
      return 'info-circle';
    },
    onResizeBannerWrapper() {
      if (this.$refs.announcementsBanners && (this.$refs.announcementsBanners.clientHeight || this.$refs.announcementsBanners.clientHeight === 0)) {
        this.$store.state.app.bannerHeight = this.$refs.announcementsBanners.clientHeight;
      }
    }
  }
};